"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StateMap = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _SvgMap = _interopRequireDefault(require("../SvgMap"));

var _StateLayer = _interopRequireDefault(require("./StateLayer"));

var _styles = require("@material-ui/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = {
  shape: {},
  text: {}
};
/**
 * A simple state level map based on `react-simple-maps`.  This map uses @material-ui/styles for theming.
 *
 * any additional props are passed to the [Composable Map Component](https://www.react-simple-maps.io/docs/composable-map/)
 *
 * To override styles use the [Higher-order Component API](https://material-ui.com/styles/basics/#hook-api) or [Hook API](https://material-ui.com/styles/basics/#hook-api)
 *
 * **Higher-order Component API example:**
 *
 *     const StyledStatesMap = withStyles({
 *       hover: { strokeWidth: 4, stroke: "#669" },
 *       hovered: { fill: "#eef" },
 *       shape: { fill: "#ccf", stroke: "#99c" },
 *       text: { fill: "#444" },
 *     })(StateMap);
 *
 * <br />
 *
 * ## Class names
 *
 * These keys can be used to override styles on the map
 *
 * | key          |                                              |
 * |--------------|----------------------------------------------|
 * | `root`       | root of the map                              |
 * | `group`      | group of state layers                        |
 * | `shape`      | individual state shapes                      |
 * | `hovered`    | state shape style when hovered               |
 * | `selected`   | state shape style when selected              |
 * | `hover`      | the hover outline                            |
 * | `label`      | the label container (`<g>`)                    |
 * | `marker`     | marker group for state label                 |
 * | `annotation` | annotation group for state pointer and label |
 * | `text`       | text element with state label                |
 */

var StateMap = function StateMap(_ref) {
  var showLabels = _ref.showLabels,
      interactive = _ref.interactive,
      onHover = _ref.onHover,
      onSelect = _ref.onSelect,
      layerProps = _ref.layerProps,
      source = _ref.source,
      _ref$classes = _ref.classes,
      rootClass = _ref$classes.root,
      groupClass = _ref$classes.group,
      hoverClass = _ref$classes.hover,
      remainingClasses = _objectWithoutProperties(_ref$classes, ["root", "group", "hover"]),
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["showLabels", "interactive", "onHover", "onSelect", "layerProps", "source", "classes", "className", "children"]);

  return /*#__PURE__*/_react["default"].createElement(_SvgMap["default"], _extends({
    className: (0, _clsx["default"])(rootClass, className),
    classes: {
      hover: hoverClass
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_StateLayer["default"], _extends({
    className: groupClass,
    classes: remainingClasses,
    source: source,
    onHover: onHover,
    onSelect: onSelect,
    showLabels: showLabels,
    interactive: interactive
  }, layerProps)), children);
};

exports.StateMap = StateMap;
StateMap.defaultProps = {
  source: "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json",
  layerProps: {},
  classes: {}
};
StateMap.propTypes = {
  /** URL to geojson source */
  source: _propTypes["default"].string,

  /** show state labels on the map */
  showLabels: _propTypes["default"].bool,

  /** allow hover / click on the state layer */
  interactive: _propTypes["default"].bool,

  /** props to forward to the GeoJsonLayer */
  layerProps: _propTypes["default"].object,

  /** object of class names to use for the component */
  classes: _propTypes["default"].object,

  /** handler for when shape is hovered */
  onHover: _propTypes["default"].func,

  /** handler for when shape is selected */
  onSelect: _propTypes["default"].func
};
var exportComponent = (0, _styles.withStyles)(styles, {
  name: "HypStateMap"
})(StateMap);
exportComponent.displayName = "StateMap";
var _default = exportComponent;
exports["default"] = _default;